module.exports = __webpack_public_path__ + "static/img/result_ceil_ust.e85c0b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ceil_ust.jpg
// module id = 2MB4
// module chunks = 3